import './container.css'

const ELEMENT_NAME = 'wp-container'

/**
 * A custom web component representing a Container
 *
 * Usage:
 * ```html
 * <wp-container></wp-container>
 * ```
 *
 * You can also create it programmatically:
 * ```js
 * const container = new Container();
 * document.body.appendChild(container);
 * ```
 */
export default class Container extends HTMLElement {
  static observedAttributes = ['label', 'style']

  static defaultTag = ELEMENT_NAME

  constructor () {
    super()

    this.$componentInfo = {
      // Component specific state
      elementId: `${ELEMENT_NAME}_` + Math.random().toString(36).substring(2, 9)
    }
  }

  connectedCallback () {
    // console.log(`Custom element added to page: ${ELEMENT_NAME} id=${this.$componentInfo.elementId}`)
    this.render()
  }

  disconnectedCallback () {
    // Remove listener when Button is removed
  }

  render () {
    this.setAttribute('data-id', this.$componentInfo.elementId)
  }
}

if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(ELEMENT_NAME, Container)
}
